import type { Collection } from 'state/utils/types';

import type { FieldDirection, FormOrientation, ProductDescriptionLoadingStatus, Width } from './types';

export type ProductNode = Readonly<{
  id: string;
  translationKey?: string;
  tooltipTranslationKey?: string;
  type?: string;
  width?: Width;
  form?: FormOrientation;
  labelSize?: number;
  children?: ReadonlyArray<ProductNode>;
  direction?: FieldDirection;
  isForAdvancedMode?: boolean;
}>;

export type ProductGraph = ReadonlyArray<ProductNode>;

export type ProductDescriptionByProductType = Collection<ProductGraph>;

export type ProductDescriptionByProductTypeAndView = Collection<Collection<ProductDescriptionByProductType>>;

export type GimmicksByName = Collection<ProductNode>;
export type ProductDescriptionResult = Readonly<{
  products: ProductDescriptionByProductTypeAndView;
  gimmicks: GimmicksByName;
  addonDescriptions: ProductGraph;
  status?: ProductDescriptionLoadingStatus;
}>;
export type ProductDescriptionState = ProductDescriptionResult;

export const initialProductDescriptionState: ProductDescriptionState = {
  products: {},
  gimmicks: {},
  addonDescriptions: [],
};
